module.exports = __webpack_public_path__ + "img/varied_lights_2.84cf25b9.png";